import React from "react";
import SearchInput from "../searchInput/searchInput";
import type { PageHeaderModel } from "../../type/header";
import "./pageHeader.scss";

const PageHeader: React.FC<PageHeaderModel> = ({ title, icon, addButton, search }) => {
  return (
    <div className="page-header">
      <div className="page-header__left">
        <h2 className="page-header__title">
          <i className={`bi ${icon} me-2`}></i>
          {title}
        </h2>
        {addButton && (
          addButton.disabled ? (
            <span title={addButton.title} className="d-inline-block">
              <button
                className={`btn btn-${addButton.variant ?? 'primary'} page-header__add-btn`}
                onClick={addButton.onClick}
                disabled={addButton.disabled}
                style={{ pointerEvents: 'none' }}
              >
                <i className="bi bi-plus-lg me-2"></i>
                <span className="page-header__add-btn-text">{addButton.label}</span>
                <span className="page-header__add-btn-text-mobile">
                  {addButton.mobileLabel ?? "Add"}
                </span>
              </button>
            </span>
          ) : (
            <button
              className={`btn btn-${addButton.variant ?? 'primary'} page-header__add-btn`}
              onClick={addButton.onClick}
              disabled={addButton.disabled}
              title={addButton.title}
            >
              <i className="bi bi-plus-lg me-2"></i>
              <span className="page-header__add-btn-text">{addButton.label}</span>
              <span className="page-header__add-btn-text-mobile">
                {addButton.mobileLabel ?? "Add"}
              </span>
            </button>
          )
        )}
      </div>

      {search && (
        <SearchInput
          value={search.value}
          onChange={search.onChange}
          placeholder={search.placeholder ?? "Search..."}
          className="page-header__search"
        />
      )}
    </div>
  );
};

export default PageHeader;